// extracted by css-extract-rspack-plugin
var _1 = "KNWumVP73WCySiqkchozPQ--";
export { _1 as "th" }
